import React from "react";
import { Helmet } from "react-helmet";
import { DEFAULT_SEO, SITE_URL } from "../config/site";

export default function Seo({ title, description, path = "", noindex = false, follow = true, type = "website" }) {
  const canonical = `${SITE_URL}${path || "/"}`;
  const image = `${SITE_URL}/og-cover.svg`;
  return (
    <Helmet>
      <html lang="en" />
      <title>{title || DEFAULT_SEO.title}</title>
      <meta name="description" content={description || DEFAULT_SEO.description} />
      <meta name="robots" content={noindex ? `noindex,${follow ? "follow" : "nofollow"}` : "index,follow"} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title || DEFAULT_SEO.title} />
      <meta property="og:description" content={description || DEFAULT_SEO.description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content="QueMe — virtual queues without the guesswork" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || DEFAULT_SEO.title} />
      <meta name="twitter:description" content={description || DEFAULT_SEO.description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
